import {
  IonLabel,
  IonCheckbox,
  IonItem,
  IonCard,
  IonCardContent,
  IonCol,
  IonFabButton,
  IonIcon,
  IonInput,
  IonButton,
  IonRow,
  IonList,
  IonRadioGroup,
  IonRadio,
} from "@ionic/react";
import React, { useState, useEffect } from "react";
import { add } from "ionicons/icons";

const ListSingleSelect = ({
  setSubmitQuestion,
  setSelected,
  selected,
  setQuestionDetails,
  elementAndPageId,
  setElementAndPageId,
  setUnchecked,
  unchecked,
}) => {
  const [inputOptions, setInputOptions] = useState(
    elementAndPageId && elementAndPageId.e1.choices.length > 0
      ? elementAndPageId.e1.choices
      : []
  );
  const [inputValue, setInputValue] = useState(null);
  const [newOption, setNewOption] = useState(null);

  useEffect(() => {
    console.log(elementAndPageId);
    if (selected === "listsingleselect") {
      if (inputOptions && inputOptions.length) {
        setSubmitQuestion(true);
        setQuestionDetails({ type: "listsingleselect", choices: inputOptions });
      } else {
        setSubmitQuestion(false);
        // setInputValue(null);
        // setNewOption(null);
        // inputOptions([]);
      }
    }
  }, [
    inputOptions,
    setUnchecked,
    selected,
    elementAndPageId,
    setSubmitQuestion,
    setQuestionDetails,
    setElementAndPageId,
  ]);

  // useEffect(() => unchecked && setInputOptions([]), [inputOptions, unchecked]);

  // const customAlertOptions = {
  //   cssClass: "custom-button-class",
  // };

  const optionHandler = (trigger, input) => {
    if (trigger === "add") {
      setInputOptions([...inputOptions, input]);
    }

    if (trigger === "delete") {
      let newArr = [...inputOptions];
      newArr.splice(input, 1);

      setInputOptions(newArr);
    }
    setNewOption(false);
    setInputValue(null);
  };

  return (
    <>
      {!selected ? (
        <IonCol size="6">
          <div style={{ minHeight: "235px", display: "flex" }}>
            <div>
              <IonCheckbox
                checked={selected === "listsingleselect"}
                value={"listsingleselect"}
                onIonChange={(e) => {
                  if (e.detail.checked) setSelected(e.detail.value);
                  else {
                    // setInputOptions([]);
                    setSelected(null);
                    // setUnchecked(true);
                  }
                }}
              />
            </div>
            <IonCard style={{ width: "100%", margin: "0px 10px" }}>
              <IonItem>
                <IonLabel>List (Einzelauswahl)</IonLabel>
              </IonItem>

              <IonCardContent>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div>Beispiel:</div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      outline: "solid #0000005e 1px",
                      padding: "10px 0px",
                      margin: "10px 0px",
                      minHeight: "75px",
                    }}
                  >
                    <IonRadioGroup
                      value={null}
                      // onIonChange={(e) => setSelected(e.detail.value)}
                    >
                      <IonItem lines="none">
                        <IonLabel>Gut</IonLabel>
                        <IonRadio slot="start" value="biff" />
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel>Schlecht</IonLabel>
                        <IonRadio slot="start" value="griff" />
                      </IonItem>
                    </IonRadioGroup>
                  </div>
                </div>
              </IonCardContent>
            </IonCard>
          </div>
        </IonCol>
      ) : selected === "listsingleselect" ? (
        <>
          <IonCol size="12">
            <div style={{ minHeight: "135px", display: "flex" }}>
              <div>
                <IonCheckbox
                  checked
                  value={"listsingleselect"}
                  onIonChange={(e) => {
                    e.detail.checked
                      ? setSelected(e.detail.value)
                      : setSelected(null);
                  }}
                />
              </div>
              <IonCard style={{ width: "100%", margin: "0px 10px" }}>
                <IonItem>
                  <IonLabel>List (Einzelauswahl)</IonLabel>
                </IonItem>

                <IonCardContent>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>Vorschau:</div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        outline: "solid #0000005e 1px",
                        padding: "10px 0px",
                        margin: "10px 0px",
                        minHeight: "75px",
                      }}
                    >
                      <IonRadioGroup
                        value={null}
                        // onIonChange={(e) => setSelected(e.detail.value)}
                      >
                        {inputOptions.map((e, ind) => (
                          <IonItem lines="none" key={ind}>
                            <IonLabel>{e}</IonLabel>
                            <IonRadio slot="start" value={e} />
                          </IonItem>
                        ))}
                      </IonRadioGroup>
                    </div>
                  </div>
                </IonCardContent>
              </IonCard>
            </div>
          </IonCol>
          <IonCol size="12">
            <IonRow
              style={{ display: "flex", alignItems: "center", height: "100px" }}
              className="ion-padding"
            >
              <div style={{ paddingRight: "10px" }}>
                <IonFabButton onClick={() => setNewOption(true)}>
                  <IonIcon icon={add} />
                </IonFabButton>
              </div>
              {newOption ? (
                <>
                  <IonItem>
                    <IonInput
                      value={inputValue}
                      placeholder={"Enter New Option"}
                      onIonChange={(e) => setInputValue(e.detail.value)}
                    ></IonInput>
                  </IonItem>
                  <IonButton
                    onClick={() => optionHandler("add", inputValue)}
                    color="primary"
                  >
                    Speichern
                  </IonButton>
                  <IonButton
                    onClick={() => {
                      setNewOption(false);
                      setInputValue(null);
                    }}
                    color="primary"
                  >
                    Abbrechen
                  </IonButton>
                </>
              ) : (
                "Option hinzufügen"
              )}
            </IonRow>
            <IonRow className="ion-padding-start">
              <IonList style={{ width: "100%" }}>
                {inputOptions &&
                  inputOptions.map((e, ind) => (
                    <IonItem key={ind}>
                      <IonLabel>{e}</IonLabel>
                      <IonButton
                        onClick={() => optionHandler("delete", ind)}
                        slot="end"
                      >
                        Löschen
                      </IonButton>
                    </IonItem>
                  ))}
              </IonList>
            </IonRow>
          </IonCol>
        </>
      ) : null}
    </>
  );
};

export default ListSingleSelect;
